import BaseChart from 'components/BaseChart/BaseChart';
import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import { useMemo } from 'react';
import { buildCombinedChartOption } from '../../utils/combinedChartOptions.utils';

/** Fits the forecast plot and touch controls to the space available inside this widget. */
const CombinedChartContent = ({
  chartId,
  chartData,
  chartStyle,
  dimensions,
  isLoading,
  type,
  containerWidth,
}) => {
  const option = useMemo(
    () => buildCombinedChartOption({ chartData, type, containerWidth }),
    [chartData, type, containerWidth],
  );

  if (isLoading && !chartData) {
    return <WidgetLoadingAnimation widgetName="Charts" dimensions={dimensions} />;
  }

  // Keep zoom when only the width changes; a different chart starts with its own axes and series.
  return (
    <BaseChart key={chartId} option={option} customStyles={chartStyle} showResetZoom lazyUpdate />
  );
};

export default CombinedChartContent;
